import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import CreateEntityDrawer from '../../common/create-entity-drawer/create-entity-drawer';
import { useContext } from 'react';
import { AuthContext } from '../../../contexts/user-context/user-context';
import MerchantCreatePickupLocationForm from './merchant-create-pickup-form/merchant-create-pickup-form';
import MerchantPickupsListing from './merchant-pickup-listing/merchant-pickup-listing';

function MerchantPickups() {
  const { user, config } = useContext(AuthContext);

  return (
    <div>
      <Box>
        <Typography
          variant="h3"
          component="h3"
          sx={{ textAlign: 'center', mt: 3, mb: 3 }}
        >
          My Pickup Locations
        </Typography>

        <br />

        {
          <Grid container spacing={2}>
            <Grid
              xs={12}
              sx={{
                textAlign: 'right',
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 1,
              }}
            >
              <CreateEntityDrawer>
                <MerchantCreatePickupLocationForm />
              </CreateEntityDrawer>
            </Grid>
            <Grid xs={12}>
              <MerchantPickupsListing />
            </Grid>
          </Grid>
        }
      </Box>
    </div>
  );
}

export default MerchantPickups;
